import { Link } from "react-router-dom";
import clsx from "clsx";

interface BreadcrumbsProps {
  breadcrumbs: {
    path?: string;
    label: string;
  }[];
  showCurrent?: boolean; // 是否顯示最後一個項目
  color?: "dark" | "light";
}

const Breadcrumbs = ({ breadcrumbs, showCurrent = true, color = "dark" }: BreadcrumbsProps) => {
  const visibleCrumbs = showCurrent ? breadcrumbs : breadcrumbs.slice(0, -1);

  return (
    <nav
      aria-label="breadcrumb"
      className="brand-scrollbar-hidden breadcrumbs overflow-x-auto text-sm"
    >
      <ul
        className={clsx("flex flex-nowrap lg:flex-wrap", {
          "[&>li+li]:before:text-secondary": color === "dark",
          "opacity-90 [&>li+li]:before:text-white": color === "light",
        })}
      >
        {visibleCrumbs.map((breadcrumb, index) => {
          const isLast = index === visibleCrumbs.length - 1;
          const ariaCurrent = showCurrent && isLast ? "page" : undefined;

          return (
            <li key={breadcrumb.path || `${breadcrumb.label}-${index}`}>
              {breadcrumb.path ? (
                <Link
                  to={breadcrumb.path}
                  aria-current={ariaCurrent}
                  className={clsx("brand-link", {
                    "text-neutral hover:text-primary": color === "dark",
                    "text-base-200 hover:text-white": color === "light",
                  })}
                >
                  {breadcrumb.label}
                </Link>
              ) : (
                <span
                  aria-current={ariaCurrent}
                  className={clsx({
                    "text-neutral": color === "dark",
                    "text-base-200": color === "light",
                  })}
                >
                  {breadcrumb.label}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Breadcrumbs;
